import Vue from "vue";

import AccountLogin from "@Scripts/Components/Account/AccountLogin.vue";
import AccountLogout from "@Scripts/Components/Account/AccountLogout.vue";
import AccountExternalRegister from "@Scripts/Components/Account/AccountExternalRegister.vue";
import AccountRegister from "@Scripts/Components/Account/AccountRegister.vue";
import AccountEdit from "@Scripts/Components/Account/AccountEdit.vue";
import AccountProfileEdit from "@Scripts/Components/Account/AccountProfileEdit.vue";
import AccountEmailConfirmSend from "@Scripts/Components/Account/AccountEmailConfirmSend.vue";
import AccountPasswordRemind from "@Scripts/Components/Account/AccountPasswordRemind.vue";
import AccountPasswordReset from "@Scripts/Components/Account/AccountPasswordReset.vue";

import BusinessRegister from "@Scripts/Components/Business/BusinessRegister.vue";

import NewsletterSubscribe from "@Scripts/Components/Newsletter/NewsletterSubscribe.vue";
import NewsletterUnsubscribe from "@Scripts/Components/Newsletter/NewsletterUnsubscribe.vue";

import Dialog from "@Scripts/Components/Dialog/Dialog.vue";

import PayPalBanner from "@Scripts/Components/PayPalBanner/PayPalBanner.vue";

export default class AppConfig {
    public static AddComponents() {
        Vue.component("app-accountlogin", AccountLogin);
        Vue.component("app-accountlogout", AccountLogout);
        Vue.component("app-accountexternalregister", AccountExternalRegister);
        Vue.component("app-accountregister", AccountRegister);
        Vue.component("app-accountedit", AccountEdit);
        Vue.component("app-accountprofileedit", AccountProfileEdit);
        Vue.component("app-accountemailconfirmsend", AccountEmailConfirmSend);
        Vue.component("app-accountpasswordremind", AccountPasswordRemind);
        Vue.component("app-accountpasswordreset", AccountPasswordReset);

        Vue.component("app-businessregister", BusinessRegister);

        Vue.component("app-newslettersubscribe", NewsletterSubscribe);
        Vue.component("app-newsletterunsubscribe", NewsletterUnsubscribe);

        Vue.component("app-dialog", Dialog);

        Vue.component("app-paypalbanner", PayPalBanner);
    }
}